import React, { useContext,useState } from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'
import { AuthContext } from "../Routes/AuthProvider"
import { ChangeUserPassword } from "../Services/ProfileUpdateApi"

const ChangePassword = () => {

    const { userName } = useContext(AuthContext);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

const handleChangePassword = async () => {

    if (!oldPassword.trim()) {
        alert("Old Password is required");
        return;
    }

    if (!newPassword.trim()) {
        alert("New Password is required");
        return;
    }

    if (!confirmPassword.trim()) {
        alert("Confirm Password is required");
        return;
    }

    if (newPassword !== confirmPassword) {
        alert("New Password and Confirm Password do not match");
        return;
    }

    try {
        setLoading(true);

        const payload = {
            userName,
            oldPassword,
            newPassword,
            confirmPassword,
        };

        const response = await ChangeUserPassword(payload);

        if (response?.success) {
            alert(response.message);
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } else {
            alert(response?.message || "Failed to change password.");
        }

    } catch (error) {

        const errorMessage =
            error.response?.data?.message ||
            "Something went wrong while changing password.";

        alert(errorMessage);

    } finally {
        setLoading(false);
    }
};




    return (
        <>
            {loading && (
                <p className="text-center load"><span className="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Change Password</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/Settings/UserAdmin" className="text-muted text-hover-primary">Change Password</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className='headings'>Change Password</h3>
                        </div>

                    </div>
                    <div className='col-md-4 mt-3'>
                        <div className='form_control'>
                            <label>Enter Old Password</label>
                            <input
                                type='password'
                                className='form-control'
                                placeholder='Enter Old Password'
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />

                            {/* <input type='text' className='form-control' placeholder='Enter Old Password' /> */}
                        </div>
                    </div>
                    <div className='col-md-4 mt-3'>
                        <div className='form_control'>
                            <label>Enter New Password</label>
                            <input
                                type='password'
                                className='form-control'
                                placeholder='Enter New Password'
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />

                        </div>
                    </div>
                    <div className='col-md-4 mt-3'>
                        <div className='form_control'>
                            <label>Confirm New password</label>
                            <input
                                type='password'
                                className='form-control'
                                placeholder='Confirm New Password'
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />

                        </div>
                    </div>
                    <div className='col-md-4 mt-3'>
                        <button
                            className="btn btn-primary"
                            onClick={handleChangePassword}
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Change Password"}
                        </button>
                        {/* <button class="btn btn-primary FormNewPassword">Change password </button> */}
                    </div>
                </div>



            </section>

        </>
    )
};

export default ChangePassword;